import type { FunctionComponent } from 'react'
import {
  AloneListenIcon,
  AndroidIcon,
  ApartmentBlockIcon,
  AppleAndroidIcon,
  AppleIcon,
  AudioIcon,
  AudioVideoIcon,
  BatteryIcon,
  BladeIcon,
  BrowserIcon,
  BrowsersIcon,
  BrowserVideoIcon,
  CarpetIcon,
  DrillIcon,
  DryBlendIcon,
  EightFtIcon,
  ElectricIcon,
  ElevenFtIcon,
  ExtenderWifiIcon,
  FairlyImportantIcon,
  FloorBoardIcon,
  GasElectricIcon,
  GasIcon,
  GpsBatteryIcon,
  GpsIcon,
  HalfTimerIcon,
  HeavyWeightIcon,
  HighCountIcon,
  HighEnergyIcon,
  HighScoreIcon,
  HomeCinemaIcon,
  HomeIcon,
  HomeOutsideIcon,
  LightWeightIcon,
  LowCountIcon,
  LowEnergyIcon,
  LowScoreIcon,
  MansionIcon,
  MediumCountIcon,
  MediumEnergyIcon,
  MediumScoreIcon,
  MeshWifiIcon,
  MiddleWeightIcon,
  MixedVegIcon,
  MixtureListenIcon,
  NoAnswerIcon,
  NoScoreIcon,
  NotImportantIcon,
  NotSureIcon,
  OrangeIcon,
  OutsideIcon,
  PhotosIcon,
  QuarterTimerIcon,
  RouterWifiIcon,
  SixCalendarIcon,
  SlightlyImportantIcon,
  SmoothBlendIcon,
  SofaIcon,
  SolidBlendIcon,
  SoundBarIcon,
  TabletAppsIcon,
  TenFtIcon,
  ThreeCalendarIcon,
  ThreequarterTimerIcon,
  TogetherListenIcon,
  TvSpeakerIcon,
  TwoCalendarIcon,
  VeryImportantIcon,
  VideoEditingIcon,
  VideosPhotosIcon,
} from '@which/seatbelt/src/components/Icons/Filters'

type IconMap = {
  [name: string]: FunctionComponent
}

export const iconMap: IconMap = {
  AloneListenIcon: AloneListenIcon,
  AndroidIcon: AndroidIcon,
  ApartmentBlockIcon: ApartmentBlockIcon,
  AppleIcon: AppleIcon,
  AppleAndroidIcon: AppleAndroidIcon,
  AudioIcon: AudioIcon,
  AudioVideoIcon: AudioVideoIcon,
  BatteryIcon: BatteryIcon,
  BladeIcon: BladeIcon,
  BrowserIcon: BrowserIcon,
  BrowserVideoIcon: BrowserVideoIcon,
  BrowsersIcon: BrowsersIcon,
  CarpetIcon: CarpetIcon,
  DrillIcon: DrillIcon,
  DryBlendIcon: DryBlendIcon,
  EightFtIcon: EightFtIcon,
  ElectricIcon: ElectricIcon,
  ElevenFtIcon: ElevenFtIcon,
  ExtenderWifiIcon: ExtenderWifiIcon,
  FairlyImportantIcon: FairlyImportantIcon,
  FloorBoardIcon: FloorBoardIcon,
  GasIcon: GasIcon,
  GasElectricIcon: GasElectricIcon,
  GpsIcon: GpsIcon,
  GpsBatteryIcon: GpsBatteryIcon,
  HalfTimerIcon: HalfTimerIcon,
  HeavyWeightIcon: HeavyWeightIcon,
  HighCountIcon: HighCountIcon,
  HighEnergyIcon: HighEnergyIcon,
  HighScoreIcon: HighScoreIcon,
  HomeIcon: HomeIcon,
  HomeCinemaIcon: HomeCinemaIcon,
  HomeOutsideIcon: HomeOutsideIcon,
  LightWeightIcon: LightWeightIcon,
  LowCountIcon: LowCountIcon,
  LowEnergyIcon: LowEnergyIcon,
  LowScoreIcon: LowScoreIcon,
  MansionIcon: MansionIcon,
  MediumCountIcon: MediumCountIcon,
  MediumEnergyIcon: MediumEnergyIcon,
  MediumScoreIcon: MediumScoreIcon,
  MeshWifiIcon: MeshWifiIcon,
  MiddleWeightIcon: MiddleWeightIcon,
  MixedVegIcon: MixedVegIcon,
  MixtureListenIcon: MixtureListenIcon,
  NoAnswerIcon: NoAnswerIcon,
  NoScoreIcon: NoScoreIcon,
  NotImportantIcon: NotImportantIcon,
  NotSureIcon: NotSureIcon,
  OrangeIcon: OrangeIcon,
  OutsideIcon: OutsideIcon,
  PhotosIcon: PhotosIcon,
  QuarterTimerIcon: QuarterTimerIcon,
  RouterWifiIcon: RouterWifiIcon,
  SixCalendarIcon: SixCalendarIcon,
  SlightlyImportantIcon: SlightlyImportantIcon,
  SmoothBlendIcon: SmoothBlendIcon,
  SofaIcon: SofaIcon,
  SolidBlendIcon: SolidBlendIcon,
  SoundBarIcon: SoundBarIcon,
  TabletAppsIcon: TabletAppsIcon,
  TenFtIcon: TenFtIcon,
  ThreeCalendarIcon: ThreeCalendarIcon,
  ThreequarterTimerIcon: ThreequarterTimerIcon,
  TogetherListenIcon: TogetherListenIcon,
  TvSpeakerIcon: TvSpeakerIcon,
  TwoCalendarIcon: TwoCalendarIcon,
  VeryImportantIcon: VeryImportantIcon,
  VideoEditingIcon: VideoEditingIcon,
  VideosPhotosIcon: VideosPhotosIcon,
}

export const getIconComponent = (name: string) => {
  return iconMap[name]
}
